import type { AtmospherePreset } from '../presets.config';
import { ATMOSPHERE_PALETTE as P } from '../palette';

/** Subtle — the ability grounds shouldn't fight the VFX QA. A few faint motes only. */
export const SUBTLE: AtmospherePreset = {
  id: 'subtle',
  layers: [
    {
      kind: 'fireflies',
      count: 8, colors: [P.firefly, P.cyan],
      sizeMin: 5, sizeMax: 10, driftPx: 20,
      periodMinMs: 8000, periodMaxMs: 15000, alphaMin: 0.1, alphaMax: 0.45,
    },
  ],
};
